"use client"

import { useEffect } from "react"
import { ErrorState } from "@/components/error-state"

/**
 * Route-level error boundary for public pages. Renders inside the root
 * layout, so the site Header and Footer remain available.
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Surfaces in the server logs / error reporting; swap for your monitoring
    // client (Sentry, etc.) if you add one.
    console.error("Route error:", error)
  }, [error])

  return (
    <main className="home min-h-screen bg-paper">
      <ErrorState
        code="500"
        eyebrow="Something went wrong"
        title="We hit an"
        titleAccent="unexpected problem."
        description="The page could not be loaded. Please try again — if the problem continues, let us know and we will look into it."
        links={[
          { href: "/", label: "Home" },
          { href: "/events", label: "Events" },
          { href: "/contact", label: "Report an issue" },
        ]}
      />
    </main>
  )
}